module.exports = __webpack_public_path__ + "img/advisory_index_solve01.4498f754.png";